import React from "react";
import { Navigate } from "react-router-dom";

const AdminRouteProtect = ({ children }) => {
  const isAuthenticated = localStorage.getItem("role_id"); 

  if (isAuthenticated==1) {
    return <Navigate to="/" replace />;
  }
  return children;
};
export default AdminRouteProtect;
